<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">筛选</h1>-->
    <!--</header>-->
    <div class="mui-content">
      <div class="title-name">
        <span class="">筛选</span>
      </div>
      <div style="padding-top: 10px;margin-top: 15px;">
        <!--第一行-->
        <div class="form-group">
          <div class="input-label">
            <label>外注订单:</label>
          </div>
          <div class="form-input">
            <input type="text" v-model="searchifo.ddh" maxlength="15" />
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label>物料名称:</label>
          </div>
          <div class="form-input">
            <input type="text" v-model="searchifo.scxtwpmc" maxlength="60" />
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">外注订单:</label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 4;" :data-options='dataoptions' v-model="searchifo.contractdate_fr" @tap="showpicker(1)" />
            <span class="input-label" style="flex:5;text-align: center">
                （开始）
            </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label"></label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex: 4;" :data-options='dataoptions' v-model="searchifo.contractdate_to" @tap="showpicker(2)" />
            <span class="input-label" style="flex:5;text-align: center;">
                （结束）
            </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">交货期:</label>
          <div class="form-input" style="display: flex;">
            <input type="text" style="flex:4;" :data-options='dataoptions' v-model="searchifo.hyqdhrq" @tap="showpicker(3)" />
            <span class="input-label" style="flex:5;text-align: center;">
                （截至日期）
            </span>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label">原料提供:</label>
          <div class="form-input" style="display: flex;padding-top: 4px;">
            <div class="mui-input-row mui-radio mui-left">
              <input type="radio" style="vertical-align: middle;" v-model="searchifo.rawprovideflag" value="0">
              <label style="vertical-align: middle;">提供</label>
            </div>
            <div class="mui-input-row mui-radio mui-left">
              <input type="radio" v-model="searchifo.rawprovideflag" value="1">
              <label>不提供</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="input-label"></label>
          <div class="form-input" style="display: flex;padding-top: 4px;">
            <div class="mui-input-row mui-checkbox mui-left">
              <label style="font-size: 14px;">仅表示物料未完成订单</label>
              <input type="checkbox" v-model="searchifo.zt" value="true">
            </div>
          </div>
        </div>
        <div class="form-group" style="width:100%;margin-top: 30px;">
          <button type="button" class="mui-btn btn-blue mui-btn-primary " style="margin: auto;width: 80px;height: 40px;" @click="confirm">
            <span class="mui-icon iconfont icon-filter" style="vertical-align: middle;"></span>
            <span style="vertical-align: middle;">确定</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "orderFilter",
  data() {
    return {
      searchifo: {
        ddh: "",
        scxtwpmc: "",
        contractdate_fr: "",
        contractdate_to: "",
        hyqdhrq: "",
        rawprovideflag: "1",
        zt: ""
      },
      dataoptions: '{"type":"date"}'
    }
  },
  created() {},
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.searchifo = para;
    } else {
      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date);
      date.setDate(date.getDate() - 7); //设置天数 -7 天
      var from_date = v.getFormatDate(date);
      v.searchifo = {
        ddh: "",
        scxtwpmc: "",
        contractdate_fr: from_date,
        contractdate_to: now_date,
        hyqdhrq: now_date,
        rawprovideflag: "1",
        zt: ""
      };
    }
  },
  methods: {
    confirm() {
      this.eventBus.$emit('searchifo', this.searchifo);
      this.$router.go(-1);
    },
    showpicker(type) {
      var v = this;
      var dDate = new Date();
      var optionsJson = v.dataoptions;
      var options = JSON.parse(optionsJson);
      var picker = new mui.DtPicker(options);
      picker.show(function(rs) {
        console.log(rs)
        var timestr = rs.text;
        if (type == 1) {
          v.searchifo.contractdate_fr = timestr.replace(/-/g, "/");
        } else if (type == 2) {
          v.searchifo.contractdate_to = timestr.replace(/-/g, "/");
        } else if (type == 3) {
          v.searchifo.hyqdhrq = timestr.replace(/-/g, "/");
        }
        picker.dispose();
      });
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  },
  watch:{
    searchifo:{
      handler: function (val) {
          this.searchifo.ddh = isZMSZ(val.ddh);
          this.searchifo.scxtwpmc = isText(val.scxtwpmc);
      },
      deep: true
    }
  }
}

</script>
<style scoped>
@import "../../static/css/filterorder.css";

</style>



// WEBPACK FOOTER //
// src/components/orderFilter.vue